import { QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60 * 2,
            gcTime: 1000 * 60 * 10,
            retry: (failureCount, error) => {
                if (error instanceof AxiosError) {
                    if (error.response?.status === 401)
                        return false;
                    if (error.response?.status === 403)
                        return false;
                    if (error.response?.status && error.response.status < 500)
                        return false;
                }
                return failureCount < 3;
            },
            retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 10000),
        },
        mutations: { retry: false },
    },
});
//# sourceMappingURL=queryClient.js.map